import React,{useState,useEffect} from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

// Reuse your existing DashboardCard component:
import DashboardCard from "../../../components/Cards/DashboardCard";

// Icons
import assign from "../../../assets/TaskManagement/assign.svg";
import inprogress from "../../../assets/TaskManagement/inprogress.svg";
import completed from "../../../assets/TaskManagement/completed.svg";
import delayed from "../../../assets/TaskManagement/delayed.svg";
import notdone from "../../../assets/TaskManagement/notdone.svg";
import cancelled from "../../../assets/TaskManagement/cancelled.svg";
import TasksTable from "./DashboardTask.js"
import { decryptToken } from "../../../Utlis/Encryption.js";
import { BASE_URL } from "../../../components/BaseUrl.js";
import CalendarView from "./DashboardCalender.js"
import RequestManagement from "./DashboardRequest.js";
import MonthlySummary from "./DashboardPunches.js";
const ReportsandStatistics = () => {
  const { t } = useTranslation();
  const [selectedTask, setSelectedTask] = useState(null);

  const [stats, setStats] = useState({
    assigned: 0,
    inProgress: 0,
    completed: 0,
    delayed: 0,
    notDone: 0,
    cancelled: 0,
  });

const rawEncryptedToken = localStorage.getItem("token");
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;
  const [selectedTaskId, setSelectedTaskId] = useState(null);
  const [taskDetails, setTaskDetails] = useState(null);
   const fetchTaskDetails = async (id) => {
    try {
      const res = await fetch(`${BASE_URL}/task-management/worker/tasks/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
           console.log("✅ Task details API:", data.data.task);

      if (!data.error) {
        // setTaskDetails(data.data.task); 
          setTaskDetails({
        ...data.data.task,
        assignments: data.data.assignments || [],
                comments: data.data.comments || []   // 👈 include comments here

      });
      }
    } catch (err) {
      console.error("❌ Error fetching task details:", err);
    }
  };
  


   useEffect(() => {
    const fetchCounters = async () => {
      try {
        const res = await fetch(`${BASE_URL}/task-management/worker/tasks/counters`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await res.json();
        console.log("✅ Counters API:", data);

        if (!data.error) {
          const c = data.data.counters;
          setStats({
            assigned: c.assigned,
            inProgress: c.in_progress,
            completed: c.completed,
            delayed: c.delayed,
            notDone: c.not_done,
            cancelled: c.cancelled,
          });
        }
      } catch (err) {
        console.error("❌ Error fetching counters:", err);
      }
    };

    if (token) fetchCounters();
  }, [token]);



  const handleSelectTask = (id) => {
    setSelectedTaskId(id);
    fetchTaskDetails(id);
     const scrollContainer = document.querySelector("#root"); // or your main wrapper
  if (scrollContainer) {
    scrollContainer.scrollTo({ top: 0, behavior: "smooth" });
  } else {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  };

  const handleBack = () => {
    setSelectedTaskId(null);
    setTaskDetails(null);
  };
  return (
    <Box sx={{px:1}}>
       
    <Box
        sx={{
          display: "grid",
          gap: 1,
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
            lg: "repeat(6, 1fr)",
          },
        }}
    >
      <DashboardCard
        icon={assign}
        title={t("tasks.cards.assigned")}
        description={stats.assigned}
      />

      <DashboardCard
        icon={inprogress}
        title={t("tasks.cards.inProgress")}
        description={stats.inProgress}
      />

      <DashboardCard
        icon={completed}
        title={t("tasks.cards.completed")}
        description={stats.completed}
      />

      <DashboardCard
        icon={delayed}
        title={t("tasks.cards.delayed")}
        description={stats.delayed}
      />

      <DashboardCard
        icon={notdone}
        title={t("tasks.cards.notDone")}
        description={stats.notDone}
      />

      <DashboardCard
        icon={cancelled}
        title={t("tasks.cards.cancelled")}
        description={stats.cancelled}
      />
    </Box>
  
    <Box>
               <TasksTable onSelectTask={handleSelectTask} />

    </Box>
      <Box>
               <RequestManagement/>

    </Box>
    <Box sx={{mt:2,}}>
      <MonthlySummary/>
    </Box>
    </Box>
   
  );
};

export default ReportsandStatistics;